import { SearchField } from '@eleveo/components-react';
import { FormApi } from 'final-form';
import React from 'react';
import { Form, FormRenderProps, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { SEARCH_QUEUES_CONTAINER_TAG, getSearchFieldsInputTag } from './constants';
import { useDebouncedField } from '../../utils/useDebounceField';
import { max255chars } from '../../utils/validations';

interface QueuesHeaderFilter {
  name: string;
}

export type QueuesHeaderFilterType = Partial<QueuesHeaderFilter>;

interface QueuesHeaderSearchFormProps {
  onSubmit: (values: QueuesHeaderFilterType, form: FormApi<QueuesHeaderFilterType>) => void;
}

const SearchForm = ({ handleSubmit }: FormRenderProps) => {
  const { t } = useTranslation();

  useFormState<QueuesHeaderFilter>({
    subscription: { dirty: true, modified: true, values: true },
    onChange: ({ modified }) => {
      // Do not fire on initial render, when updating state is causing React error
      if (modified?.name) {
        handleSubmit();
      }
    },
  });

  const { input } = useDebouncedField('name', {
    validate: max255chars,
  });

  return (
    <form data-test-id={SEARCH_QUEUES_CONTAINER_TAG}>
      <SearchField {...input} placeholder={t('form.name')} testId={getSearchFieldsInputTag('queue-name')} />
    </form>
  );
};

export const QueuesHeaderSearchForm: React.FC<QueuesHeaderSearchFormProps> = ({ onSubmit }) => {
  return <Form onSubmit={onSubmit} component={SearchForm} />;
};
